module.exports = "{{input type=\"checkbox\" checked=view.isSelected}}\n{{view.content}}"